import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Select } from "@activecollab/components";
import PropTypes from "prop-types";

export const OptionPicker = ({
  options,
  selected,
  onChange,
  className,
  defaultValue,
  defaultSelectedName,
  optionKey,
}) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);

  const selectedName = useMemo(() => {
    const result = options.find(({ id }) => id === selected)?.name;
    if (!result && defaultSelectedName) {
      return defaultSelectedName;
    }
    return result;
  }, [options, selected, defaultSelectedName]);

  const handleOpen = useCallback(() => {
    setActive(true);
  }, []);

  const handleClose = useCallback(() => {
    setActive(false);
  }, []);

  const handleChange = useCallback(
    (id) => {
      if (typeof onChange === "function") {
        onChange({ [optionKey]: id });
      }
    },
    [onChange, optionKey]
  );

  return (
    <Select
      target={
        <Button
          className={className}
          variant="text gray"
          active={active}
        >
          {selectedName}
        </Button>
      }
      onSelectOpen={handleOpen}
      onSelectClose={handleClose}
      defaultValue={defaultValue}
      noResultText={t("No result")}
      selected={selected > 0 ? selected : undefined}
      options={options}
      onChange={handleChange}
      forceCloseMenu
    />
  );
};

OptionPicker.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  selected: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  defaultSelectedName: PropTypes.string,
  optionKey: PropTypes.string.isRequired,
};
